import Raven from 'raven-js';
import * as React from 'react';
import WalmartDebugEnrollmentFilterRenderer from 'flow-doctor-lib/components/filters/WalmartDebugEnrollmentFilterRenderer';
import UnsupportedFilterBranchDescription from 'flow-doctor-lib/components/diagnosis/UnsupportedFilterBranchDescription';
import { getDebugFilterBranchWithMostAcceptances } from 'flow-doctor-lib/utils/filterDissectionUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EnrollmentAnalysisDebugBranchDescription = ({
  selectedEnrollment,
  debugFilterBranch,
  filterBranch,
  filterWidthType = 'LIST_STRETCHED'
}) => {
  const firstAcceptedFilterBranch = debugFilterBranch.acceptedFilterBranches[0];
  const filterBranchWithLeastRejections = getDebugFilterBranchWithMostAcceptances(debugFilterBranch.filterBranches);
  React.useEffect(() => {
    if (!firstAcceptedFilterBranch) {
      console.error('Found a debug enrollment analysis without an accepted filter branch');
      Raven.captureMessage('Found a debug enrollment analysis without an accepted filter branch', {
        extra: {
          selectedEnrollment,
          debugFilterBranch
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstAcceptedFilterBranch]);
  const branchToDisplay = firstAcceptedFilterBranch;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: branchToDisplay ? /*#__PURE__*/_jsx(WalmartDebugEnrollmentFilterRenderer, {
      objectTypeId: selectedEnrollment.objectTypeId,
      filterBranch: filterBranchWithLeastRejections ? filterBranch.filterBranches[filterBranchWithLeastRejections.index] : undefined,
      debugFilterBranch: branchToDisplay,
      debugDisplayMode: "ONLY_ACCEPTED",
      filterWidthType: filterWidthType
    }) : /*#__PURE__*/_jsx(UnsupportedFilterBranchDescription, {
      objectTypeId: selectedEnrollment.objectTypeId,
      filterBranch: filterBranch,
      debugFilterBranch: debugFilterBranch
    })
  });
};
export default EnrollmentAnalysisDebugBranchDescription;